// Module
var code = "<template><ul class=\"chart-legend\"><li class=\"row\" repeat.for=\"item of data\" click.delegate=\"clickItem(item, $index)\"><i class=\"indicator\" css=\"background: ${item.color}\"></i> <span class=\"label\">${item | legendStringFormat:{format:format, params:params}}</span></li></ul></template>";
// Exports
module.exports = code;